module.exports = __webpack_public_path__ + "img/nichita-naum.d71b3aed.jpg";